import { connect } from 'react-redux';
import { createSelector, createStructuredSelector } from 'reselect';
import FrameworkUtils from 'utils/framework';
import LanguageLocaleUtils from 'utils/LanguageLocale';
import ItemsInOrder from 'components/RwdCheckout/OrderSummary/ItemsInOrder/ItemsInOrder';
import resourceWrapper from 'utils/framework/resourceWrapper';
import OrderSummaryEN from 'components/RwdCheckout/OrderSummary/locales/OrderSummary_en_US.js';
import OrderSummaryFR from 'components/RwdCheckout/OrderSummary/locales/OrderSummary_fr_CA.js';
import DeliveryOptionsEN from 'components/ProductPage/DeliveryOptions/locales/DeliveryOptions_en_US.js';
import DeliveryOptionsFR from 'components/ProductPage/DeliveryOptions/locales/DeliveryOptions_fr_CA.js';

const { wrapHOC } = FrameworkUtils;
const { getTextFromResource, getLocalisedDataFromResource } = LanguageLocaleUtils;

const getText = getLocalisedDataFromResource(OrderSummaryEN, OrderSummaryFR);
const getAutoReplenText = resourceWrapper(getLocalisedDataFromResource(DeliveryOptionsEN, DeliveryOptionsFR), true);

const textResources = createStructuredSelector({
    shippingRestrictions: getTextFromResource(getText, 'shippingRestrictions'),
    freeReturns: getTextFromResource(getText, 'freeReturns'),
    onAllPurchases: getTextFromResource(getText, 'onAllPurchases'),
    qty: getTextFromResource(getText, 'qty'),
    removeText: getTextFromResource(getText, 'removeText'),
    deliveryEvery: getTextFromResource(getAutoReplenText, 'deliveryEvery'),
    autoReplenishCheckoutTermsConditions3: getTextFromResource(getAutoReplenText, 'autoReplenishCheckoutTermsConditions3')
});

const connectedItemsInOrder = connect(
    createSelector(textResources, texts => {
        return {
            ...texts,
            getAutoReplenText
        };
    })
);

const withItemsInOrderProps = wrapHOC(connectedItemsInOrder);

export default withItemsInOrderProps(ItemsInOrder);
